<template>
    <div class="w-full h-full">
        <FormModal
            v-if="showFilters"
            @cancel="showFilters=false ; offerType = []; retailerCategory = undefined"
            @confirm="showFilters=false; getRetailers(0,25)"
            :valid="true"
            title="Filter results"
            subtitle="Select from these filters to refine your search"
            submitButtonText="Apply filters"
        >
            <div class="grid gap-3">
                <CustomCheckbox v-model="offerType" :options="offerTypes" label="Select types:"/>
                <CustomSelect v-model="retailerCategory" :pre-select="retailerCategory" :options="retailerCategories" label="Select category:"/>
            </div>  
        </FormModal>
        <FormModal
            v-if="showFormModal"
            @cancel="showFormModal=false"
            @confirm="showFormModal=false; requestApproval()"
            :valid="!(activateOfferRequest.splitOfCashbackPercentage.client > 100 || activateOfferRequest.splitOfCashbackPercentage.client < 0)"
            title="Request approval"
            submitButtonText="Request"
        >
            <div>
                <p class="mb-2">Set default splits, for cashback if not preset </p>
                <CustomInput :error="pecentageNotRight" v-model="activateOfferRequest.splitOfCashbackPercentage.endUser" :min="0" :max="100" type="number" label="Your users cashback split percentage"  />
                <CustomInput v-model="activateOfferRequest.splitOfCashbackPercentage.client" type="number" :min="0" :max="100" :disabled="true" label="Your commission split percentage"  />
            </div>

        </FormModal>
        <Header
            title="Retailer catalogue"
            icon="Store"
        />
        <WhiteBox
            title="Retailer catalogue"
            subText="View and manage our integrated retailer offers which are available to use."
        >
        <template v-slot:buttons>
            <CustomButton small id="filterButton" text="Filter results" icon="Filter" type="action"
                @click="showFilters = true" />
        </template>

            <template v-slot:content>
                <div v-if="offerType && offerType.length > 0 || retailerCategory" class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Applied filters:</p>
                    <div  class="flex justify-start items-center py-1 gap-1">
                        <div v-for="offer,index in offerType" :key="index">
                        <OfferTypePill
                        :type="offer.id"
                        />
                    </div>
     
                        <div class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
                        v-if="retailerCategory"
                        >
                        <p class="text-xs font-medium text-nowrap">{{ retailerCategory }}</p>
                        </div>
                        
                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min"
                        >

                        <p class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer" @click="offerType = []; retailerCategory = undefined; getRetailers(0,25)">Clear filters</p>
                        </div>
                    </div>
                </div>
                <div class="grid mt-6">
                    <SearchBar placeholderText="Search by retailer name" @search="(val) => getRetailerBySearch(0,50,val)">
                        <CustomButton small text="" type="default" icon="X" @click="getRetailers(0,25)" />
                    </SearchBar>
                </div>
                <EasyDataTable
                    :headers="headersTable1"
                    :items="retailers"
                    :loading="loading"
                    v-model:server-options="serverOptions"
                    :server-items-length="serverItemsLength"
                    :hide-footer="false"
                    :no-hover="true"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                    <div class="flex justify-center py-4">
                        <div class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                            <p class="text-sm mr-2">No results</p>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                            </svg>
                        </div>
                    </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    
                    <template #item-retailer="retailers">
                        <LogoAndText 
                            :logo="retailers.logo"
                            :text="retailers.retailerName"
                        />
                    </template>

                    <template #item-offertype="retailers">
                        <div v-if="retailers.offerType != undefined" class="flex justify-start items-center py-1 gap-1">
                            <OfferTypePill
                                v-if="retailers.offerType.filter((offer) => offer == 'PAYMENT').length > 0"
                                type="PAYMENT"
                            />
                            <OfferTypePill
                                v-if="retailers.offerType.filter((offer) => offer == 'GIFTCARD').length > 0"
                                type="GIFTCARD"
                            />
                            <OfferTypePill
                                v-if="retailers.offerType.filter((offer) => offer == 'ONLINE').length > 0"
                                type="ONLINE"
                            />
                        </div>
                    </template>

                    <template #item-offer="retailers">
                        <div class="flex justify-start items-center py-1 gap-1">
                            {{retailers.offers.length }}
                        </div>
                    </template>
                    <!-- <template #item-offerRequested="retailers">
                        <div class="flex justify-start items-center py-1 gap-1">
                            {{retailers.programOffers.length}}/{{retailers.offersList.length }}
                        </div>
                    </template>
                    <template #item-offerApproved="retailers">
                        <div class="flex justify-start items-center py-1 gap-1">
                           {{retailers.programOffers.filter(offer => offer.offerApproval == "APPROVED").length }}/ {{retailers.offersList.length }}
                        </div>
                    </template> -->

                    <template #item-action="retailers">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small text="Apply to all offers" type="action" @click="showFormModal=true;selectedRetailer=retailers.id"  />
                            <CustomButton small text="View Retailer" type="navigate" @click="$router.push(`/retailer-catalogue/${retailers.id}`)" />
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import SearchBar from '@/components/SearchBar.vue'
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import LogoAndText from "@/components/LogoAndText.vue";
import OfferTypePill from "@/components/OfferTypePill.vue";
import FormModal from "@/components/modals/FormModal.vue";
import CustomCheckbox from "@/components/inputs/CustomCheckbox.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";
import CustomInput from "@/components/inputs/CustomInput.vue";

export default {
	name: "manage-publsihers",
	components: {
        Header,
        WhiteBox,
		CustomButton,
        CustomCheckbox,
        CustomInput,
        CustomSelect,
        SearchBar,
        LogoAndText,
        OfferTypePill,
        FormModal
	},
	props:{
    },

	data() {
		return {
            serverOptions:{
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength:undefined,
            showFilters: false,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            pecentageNotRight:"",

            activateOfferRequest:{
                splitOfCashbackPercentage:{
                    endUser:50,
                    client:50
                },
                activate:true
            },

            selectedRetailer: undefined,
            loading:true,
            headersTable1:[
                { text: "Retailer", value: "retailer" },
                { text: "Offers Avaliable", value: "offer"},
                { text: "Offers Requested", value: "offerRequested"},
                { text: "Offers Approved", value: "offerApproved"},
                
                
                { text: "Offer types", value: "offertype"},
                { text: "Action", value: "action"},
                
            ],
            retailers:[

            ],
            retailerCategories:[
  { "id": "Buy now, pay later", "text": "Buy now, pay later" },
  { "id": "Cafes and coffee shops", "text": "Cafes and coffee shops" },
  { "id": "Clothing", "text": "Clothing" },
  { "id": "Convenience stores", "text": "Convenience stores" },
  { "id": "Department and discount stores", "text": "Department and discount stores" },
  { "id": "Donation", "text": "Donation" },
  { "id": "Drugstores and pharmacies", "text": "Drugstores and pharmacies" },
  { "id": "Education", "text": "Education" },
  { "id": "Electronics", "text": "Electronics" },
  { "id": "Entertainment and recreation", "text": "Entertainment and recreation" },
  { "id": "Food and Drink", "text": "Food and Drink" },
  { "id": "Gifts", "text": "Gifts" },
  { "id": "Groceries", "text": "Groceries" },
  { "id": "Home improvements and maintenance services", "text": "Home improvements and maintenance services" },
  { "id": "Hotels and lodging", "text": "Hotels and lodging" },
  { "id": "Laundry", "text": "Laundry" },
  { "id": "Liquor", "text": "Liquor" },
  { "id": "Media", "text": "Media" },
  { "id": "Medical bill", "text": "Medical bill" },
  { "id": "Not enough information", "text": "Not enough information" },
  { "id": "Other consumer services", "text": "Other consumer services" },
  { "id": "Other non-essential", "text": "Other non-essential" },
  { "id": "Other transport", "text": "Other transport" },
  { "id": "Pets", "text": "Pets" },
  { "id": "Recreational goods", "text": "Recreational goods" },
  { "id": "Ridesharing and taxis", "text": "Ridesharing and taxis" },
  { "id": "SaaS tools", "text": "SaaS tools" },
  { "id": "Self care", "text": "Self care" },
  { "id": "Taxes", "text": "Taxes" },
  { "id": "Utilities", "text": "Utilities" },
  { "id": "Vehicle maintenance", "text": "Vehicle maintenance" },
  { "id": "eCommerce purchase", "text": "eCommerce purchase" }
],
            offerTypes:[
                { id: "PAYMENT", text: 'Payment-linked offers' }, 
                { id: "ONLINE", text: 'Affiliate links' },
                { id: "GIFTCARD", text: 'Gift card offers' },
            ],
            activeFilters:[
                { id: "PAYMENT", filter: true }, 
                { id: "ONLINE", filter: true },
                { id: "GIFTCARD", filter: true },
                { id: "Category", filterText: "Restaurant" },
            ],
            offerType: [],
            retailerCategory: undefined,
        }
	},
	created(){
        this.getRetailers(0,25)


	},
	methods: {

        async requestApproval(){
            try {
                const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')
                this.loading = true


                const response = await fetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/apply/retailer/${this.selectedRetailer}`, {
                    method: "POST",
                    body:JSON.stringify(this.activateOfferRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getRetailers(0,25)
                }

            } catch (error) {
                console.log(error)
                return;
            }
        },

        async getRetailerBySearch(page,size,retailerSearch)
        {
            try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')


				const response = await fetch(`https://${api}.boogi.io/private/api/client/catalogue/retailer-search?page=${page}&size=${size}&search=${retailerSearch}&category=`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"Authorization": `${token}`,
					},
				});

				if (response.ok) {
					var object = await response.json()
                    this.retailers = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
				}
				
			} catch {
				return
			}
        },

        async getRetailers(page,size){
			try {
				const token = localStorage.getItem('token')
                const api  = localStorage.getItem('apiType')


                if(this.offerType.length > 0)
                {var offerType = []
                this.offerType.forEach(element => {
                    offerType.push(element.id)
                });
                console.log(offerType,"OfferType")}

                this.loading = true
                const response = await fetch(`https://${api}.boogi.io/private/api/client/catalogue/retailer?page=${page}&size=${size}${this.offerType.length > 0  ? '&type='+offerType : '' }${this.retailerCategory != undefined ? '&category='+this.retailerCategory : '' }`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `${token}`,
                        },
                    });

				if (response.ok) {
					var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.retailers = object.content  

                    this.loading = false
				}
				
			} catch (error) {
				return;
			}

		},

	},
	computed: {

	},
    mounted() {
        document.title = "Dashboard | Retailer catalogue";
    },
	watch: {
        serverOptions: {
            deep: true,
            handler(val){
                     this.getRetailers(val.page-1,val.rowsPerPage)
                }
    },
    activateOfferRequest:{
            deep:true,
            handler: function(newValue) {

                if(newValue.splitOfCashbackPercentage.endUser == "")
                {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 0

                }

                if(newValue.splitOfCashbackPercentage.endUser > 100)
                {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 100
                    this.pecentageNotRight = "The percentage needs to be less than or equal to 100"
                }
                else if(newValue.splitOfCashbackPercentage.endUser < 0)
                {
                    this.activateOfferRequest.splitOfCashbackPercentage.endUser = 0
                    this.pecentageNotRight = "The percentage needs to be greater than or equal to 0"

                }
                this.pecentageNotRight = ""
                this.activateOfferRequest.splitOfCashbackPercentage.client = 100 - newValue.splitOfCashbackPercentage.endUser
            },
        }
	}
}
</script>